export const SEQUENCE_PANEL_FIELDS = {
  PLANNED_QUANTITY: "plannedQuantity",
  HOLD: "hold",
  SHIPPER_COMPANY_CODE: "shipperCompanyCode",
  STOCK_PILE_CODE: "stockPileCode",
  CARGO_CODE: "cargoCode",
  GRADE_CODE: "gradeCode",
  GRADE_SIZE_CODE: "gradeSizeCode",
  ACTUAL_SIZE: "actualSize",
} as const;

export const MAX_ACTUAL_SIZE_LENGTH = 255;
export const MIN_HOLD = 1;
export const MAX_HOLD = 9;

// A shape check on the text the user typed (NUMERIC(14,3)): not arithmetic (HLD section 5.3).
export const PLANNED_QUANTITY_PATTERN = /^\d{1,11}(\.\d{1,3})?$/;

export const HOLD_OPTIONS = Array.from({ length: MAX_HOLD - MIN_HOLD + 1 }, (_, index) => {
  const value = String(MIN_HOLD + index);
  return { label: value, value };
});
